export const validatePlannedMaintenanceNTE = (
	rule,
	val,
	callback,
	formData,
	approvalHierarchy,
	isAdmin,
	isAssignedToInternalSupplier,
	setState,
	isSameNTE = true
) => {
	const value = parseFloat(val);
	const isEmpty = val === undefined || val === '' || isNaN(value);
	if (isEmpty && !isAssignedToInternalSupplier && isSameNTE) {
		callback(new Error(`Please enter an NTE.`));
		setState({
			nteStatus: 'error',
			nteMessage: `Please enter an NTE.`,
		});
	} else if (
		approvalHierarchy.amount &&
		value > parseInt(approvalHierarchy.amount) &&
		value !== formData.nte
	) {
		callback(
			isAdmin
				? undefined
				: new Error(
						`This NTE change bypasses the requirement of a quote. Based on approval hierarchy, you can set NTE upto $${approvalHierarchy.amount}`
				  )
		);
		setState({
			nteStatus: isAdmin ? 'warning' : 'error',
			nteMessage: `This NTE change bypasses the requirement of a quote. Based on approval hierarchy, you can set NTE upto $${approvalHierarchy.amount}`,
		});
	} else {
		callback();
		setState({
			nteStatus: undefined,
			nteMessage: undefined,
		});
	}
};

// next schedule dates past Jan 2038 can't be stored by the backend
export const MAX_PLANNED_MAINTENANCE_FREQUENCY_BY_UNIT: { [unit: string]: number } = {
	days: 2500,
	weeks: 365,
	months: 120,
	years: 10,
};

// an existing schedule saved above the cap stays editable as long as its frequency isn't raised
export const getMaxPlannedMaintenanceFrequencyAmount = (
	frequencyUnit: string,
	savedFrequencyAmount = 0
): number =>
	Math.max(
		MAX_PLANNED_MAINTENANCE_FREQUENCY_BY_UNIT[frequencyUnit] ||
			MAX_PLANNED_MAINTENANCE_FREQUENCY_BY_UNIT.days,
		savedFrequencyAmount
	);
